/**
 * How the billing summary's `status_alert` is shown. The alert is structured
 * data from the API (a `kind` and what that kind needs); the screens write the
 * copy. Anything that shows the alert shares these rules, so the app banner and
 * the billing page agree on how serious it is.
 */

export const bgClassCritical = 'bg-red-600 text-white'
export const bgClassWarning = 'bg-amber-500 text-white'
export const bgClassInfo = 'bg-sky-100 text-sky-800'

// A trial is on screen for its whole length; it turns urgent for the last days.
const URGENT_TRIAL_DAYS = 3
const CRITICAL_KINDS = new Set(['suspended', 'past_due', 'over_mac_limit'])

/**
 * How loudly the alert should speak: `critical`, `warning` or `info`.
 *
 * @param {object} statusAlert - The billing summary's `status_alert`
 * @returns {'critical'|'warning'|'info'}
 */
export function toneOf(statusAlert) {
    if (CRITICAL_KINDS.has(statusAlert?.kind)) return 'critical'
    if (statusAlert?.kind === 'trial_ending') {
        return statusAlert.days_left <= URGENT_TRIAL_DAYS ? 'warning' : 'info'
    }
    return 'warning'
}

/**
 * Banner background for an alert, chosen by the template that owns the banner
 * shell (BannerCarousel only renders the content).
 *
 * @param {object} statusAlert - The billing summary's `status_alert`
 * @returns {string}
 */
export function bgClassFor(statusAlert) {
    const tone = toneOf(statusAlert)
    if (tone === 'critical') return bgClassCritical
    if (tone === 'warning') return bgClassWarning
    return bgClassInfo
}
